import { combineReducers } from 'redux';

import DownloadTypes from './types';

export const downloadReducer = combineReducers({
  downloadFile: DownloadTypes.downloadFile.getReducer(),
  validateDownloadHash: DownloadTypes.validateDownloadHash.getReducer(),
});
